import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PosterViewModel, StringViewModel } from 'src/app/_models/generatedModels';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { PosterService } from 'src/app/_services/generatedServices';

@Component({
  selector: 'poster-feedback',
  templateUrl: 'poster-feedback.component.html',
})
export class PosterFeedbackComponent implements OnInit {
  @Input() poster: PosterViewModel;
  @Output()
  closed = new EventEmitter();
  initialized = false;
  reviewSubmitted = false;
  public formGroup: FormGroup;
  submitComplete: Promise<{}> | undefined;

  constructor(private fb: FormBuilder, private posterService: PosterService) {}

  ngOnInit(): void {
    this.formGroup = this.fb.group({
      text: ['', [Validators.required]],
    });

    this.initialized = true;
  }

  public onSave() {
    if (!this.formGroup.valid) {
      this.formGroup.markAllControlsDirty();
      return;
    }

    this.submitComplete = new Promise((resetButton:any, reject) => {
      let model = new StringViewModel();
      model.value = this.formGroup.controls.text.value;
      this.posterService.submitReview(this.poster.id, model).subscribe(
        review => {
          resetButton();
          this.reviewSubmitted = true;
        },
        error => resetButton()
      );
    });
  }

  close() {
    this.closed.emit();
  }
}
